var _defs, _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.20002 267.17702",
    xmlSpace: "preserve",
    width: 273.20001,
    height: 267.17703,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4865"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style4778"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:2.8346;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:2.94;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:1.1513;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{display:none;}\n\t.st7{display:inline;fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.20599,0,0,-1.23176,1471.4328,2827.6283)",
    id: "g4784"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 1107.9,2180.3 108.9,115.3 H 999 Z m 0,9.5 93.8,99.3 H 1014 Z",
    id: "path4782"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.43808,0,0,-1.02407,1773.0828,5458.0383)",
    id: "g4788"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 1138.9,5206 40.6,70.7 h -81.3 z",
    id: "path4786"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.530337,0,0,0.346406,85.2518,1351.7483)",
    id: "g4812"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.41632,0,0,1.38685,-1434.61,-234.191)",
    id: "g4792"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 1079.5,-2342 c 0,0 -30,68.6 -30,98 0,25.9 13.4,46.8 30,46.8 16.5,0 30,-21 30,-46.8 0,-29.5 -30,-98 -30,-98 z",
    id: "path4790"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.520881,-0.157355,0.172354,0.475554,-3601.77,-1474.55)",
    id: "g4796"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9659,0.259,-0.259,-0.9659,14600.349,-5118.3159)",
    className: "st2",
    cx: 7637.2998,
    cy: -1597.4,
    rx: 10.4,
    ry: 30.6,
    id: "ellipse4794"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683599,0,0,0.624111,-3105.94,-3638.57)",
    id: "g4800"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 4707.5,355.1 c 0,0 45.5,229 -55.3,185 22.8,22.3 136.2,12 55.3,-185 z",
    id: "path4798"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.683599,0,0,0.624111,-3105.94,-3638.57)",
    id: "g4804"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 4652.2,361.7 c 0,0 -28.1,79.3 -21.5,106.7",
    id: "path4802"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.58972,0.315656,-0.345742,0.538402,466.662,-4683.04)",
    id: "g4810"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 681,2152.2 c 0,0 -14.9,89.9 -76.7,36 -31.2,-2.7 75.5,69.7 76.7,-36 z",
    id: "path4806"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 681,2152.2 c 0,0 -3.7,22.5 -15.2,38.2 -11.5,15.7 -30.6,24.8 -61.5,-2.2 -31.2,-2.7 75.5,69.7 76.7,-36 z",
    id: "path4808"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-479.2,-446.80664)",
    id: "g4816"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 733.6,623 v 46.7 c 0,6.4 -2.5,12.5 -7.1,17 -4.5,4.5 -10.6,7.1 -17,7.1 -45.2,0 -142.1,0 -187.3,0 -6.4,0 -12.5,-2.5 -17,-7.1 -4.5,-4.5 -7.1,-10.6 -7.1,-17 V 623 h -18.9 v 61.5 c 0,6.4 2.5,12.5 7.1,17 4.5,4.5 10.6,7 17,7 51.8,0 173.2,0 225,0 6.4,0 12.5,-2.5 17,-7 4.5,-4.5 7.1,-10.6 7.1,-17 0,-25.3 0,-61.5 0,-61.5 z",
    id: "path4814"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,1.89402,-469.6572,-4760.1217)",
    id: "g4820"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.20001,
    y: 2633.8999,
    transform: "matrix(-0.998,-0.06252524,0.06252524,-0.998,839.4485,5308.2056)",
    className: "st1",
    width: 197.10001,
    height: 14.2,
    id: "rect4818"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.80899,0,0,0.516255,-984.2382,1373.8683)",
    id: "g4824"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9992,-0.03985748,0.03985748,-0.9992,1328.774,-4394.9082)",
    className: "st4",
    cx: 620.59998,
    cy: -2210.7,
    rx: 64.800003,
    ry: 8.1000004,
    id: "ellipse4822"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    id: "g4828"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 585.9,-612.5 c 0,0 2.4,16.1 -14.5,16.1 -12.2,-1.3 -28.3,-1 -41,-1.1 -19.4,-0.1 -34.4,0 -34.4,0 0,0 81.3,1.4 89.9,-15 z",
    id: "path4826"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    id: "g4832"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 377.3,-677.8 12,-1 -7.9,3.7 -1.1,62.6 c 0,0 -2,14.6 13.4,24.9 -3.2,-0.2 -16,-1.3 -17.3,-25.4 -0.1,-24.1 0.9,-64.8 0.9,-64.8 z",
    id: "path4830"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.940523,0,0,0.915179,-151.2932,798.24826)",
    id: "g4836"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 434.2,-677.1 h 8.1 c 0,0 2.4,79 -11.2,79.1 3.1,-5.8 3.2,-13.4 3.2,-13.4 z",
    id: "path4834"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    id: "g4840"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 390.8,-621.3 c 0,0 -2.6,23.1 14.3,23.4",
    id: "path4838"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    id: "g4844"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 402.9,-598 168.6,0.9",
    id: "path4842"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.10457,0,0,0.915179,-1353.9662,772.62826)",
    id: "g4850"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.9176,-0.3975,0.3975,-0.9176,1667.8895,-1218.6125)",
    className: "st2",
    cx: 707.59998,
    cy: -782.20001,
    rx: 22.5,
    ry: 6.5,
    id: "ellipse4846"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 707.6,-788.2 c 13.4,0 24.2,2.7 24.2,6 0,3.3 -10.9,6 -24.2,6 -13.3,0 -24.2,-2.7 -24.2,-6 0,-3.3 10.9,-6 24.2,-6 z m 23.3,6 c -0.4,0.4 -1.1,0.8 -1.8,1.2 -4,1.9 -12.1,3.2 -21.4,3.2 -9.3,0 -17.4,-1.3 -21.4,-3.2 -0.8,-0.4 -1.4,-0.8 -1.8,-1.2 0.4,-0.4 1.1,-0.8 1.8,-1.2 4,-1.9 12.1,-3.2 21.4,-3.2 9.3,0 17.4,1.3 21.4,3.2 0.7,0.4 1.3,0.8 1.8,1.2 z",
    id: "path4848"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    className: "st6",
    id: "g4854"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m 448.3,-841.5 8.7,25.4 -20.4,1.8 20.9,37.6 -62.3,-85.5 54.4,6.3",
    id: "path4852"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-452.3272,798.24826)",
    id: "g4860"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 396.4,-860.9 90.8,129.7 -82.7,-129.7 z",
    id: "path4856"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 396.4,-860.9 90.8,129.7 -82.7,-129.7 z m 2.8,1.6 h 4.8 l 49,76.8 z",
    id: "path4858"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2782e15f04ab5398d49f142007ced496.svg";
export { ForwardRef as ReactComponent };